import { render, staticRenderFns } from "./coverImg.vue?vue&type=template&id=27eac14e&scoped=true&"
import script from "./coverImg.vue?vue&type=script&lang=js&"
export * from "./coverImg.vue?vue&type=script&lang=js&"
import style0 from "./coverImg.vue?vue&type=style&index=0&id=27eac14e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eac14e",
  null
  
)

export default component.exports